var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.contactIsPresent)?_c('ContactCard',{attrs:{"id":Number(this.$route.params.id)}}):_c('p',[_vm._v("Контакт не найден.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }